"use client";

import React, { createContext, useContext } from "react";
import type { ComposeFormStateContextValue } from "@/lib/core/crm/types";

const ComposeFormStateContext = createContext<ComposeFormStateContextValue | null>(null);

interface ComposeFormStateProviderProps {
  children: React.ReactNode;
  value: ComposeFormStateContextValue;
}

export function ComposeFormStateProvider({
  children,
  value,
}: ComposeFormStateProviderProps) {
  return (
    <ComposeFormStateContext.Provider value={value}>
      {children}
    </ComposeFormStateContext.Provider>
  );
}

export function useComposeFormStateContext() {
  const context = useContext(ComposeFormStateContext);
  if (!context) {
    throw new Error("useComposeFormStateContext must be used within a ComposeFormStateProvider");
  }
  return context;
}
